import type { ReactNode } from 'react'

import { isNil } from 'ramda'

import { BulletIcon } from '@twistopayments/design-system/icons/inline'

import { BaseListItem } from '../base-list'

type Props = {
  children: ReactNode
  customIcon?: ReactNode
}

export const BulletedListItem = ({ children, customIcon }: Props) => {
  const hasCustomIcon = !isNil(customIcon)

  return (
    <BaseListItem
      data-testid="bulleted-list-item"
      hasGap={hasCustomIcon}
      icon={
        hasCustomIcon ? (
          customIcon
        ) : (
          <BulletIcon color="highlight" height="100%" width="100%" />
        )
      }
    >
      {children}
    </BaseListItem>
  )
}
